import { Component, OnInit } from '@angular/core';
import { AuthenticationService } from '../../services/authentication/authentication.service';
import { MatDialog } from '@angular/material/dialog';

@Component({
    selector: 'portal-logout',
    templateUrl: './logout.component.html',
    styles: [],
    standalone: false
})
export class LogoutComponent implements OnInit {

    constructor(public auth: AuthenticationService, private dialog: MatDialog) { }

    ngOnInit() {
        this.dialog.closeAll();
        localStorage.setItem('logout-event', Math.random().toString());
    }
}